import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 30px;
  overflow: hidden;
  z-index: 99999;
`
